"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const redux_observable_1 = require("redux-observable");
const _projectList = require("../../modules/project/list/epics");
const _folderTree = require("../../modules/files/tree/epics");
const _usergroupList = require("../../modules/usergroup/list/epics");
const archive = require("./archive");
const list = require("./list");
const metas = require("./metas");
const schema = require("./schema");
const wizard = require("./wizard");
const projectListEpics = _projectList.default('subproject');
const folderTreeEpics = _folderTree.default('subproject');
const userGroupListEpics = _usergroupList.default('subproject');
exports.allEpics = (0, redux_observable_1.combineEpics)(
// Archive
archive.archive, 
// List
list.fetch, 
// Metas
metas.add, metas.edit, metas.fetch, metas.remove, 
// Schema
schema.fetchSchema, schema.updatechema, 
// Wizard
wizard.validateStep, wizard.save, 
// Project list
projectListEpics.fetch, 
// Folder tree
folderTreeEpics.fetchTree, 
// User groups
userGroupListEpics.fetch);
//# sourceMappingURL=index.js.map